import React from 'react';
import Routes from './routes';
import GlobalStyle from './GlobalStyle';
import flags from './flags';
import { FlagsProvider } from 'react-feature-flags';
import { AuthProvider } from './services/auth';
import { GetData } from './services/getData';
import { GetMeuPerfil } from './services/getMeuPerfil';
import { Solicitacoes } from './services/solicitacoes';
import { ThemeProvider } from 'styled-components';
import { ListaImoveis } from './Components/ApartamentList/contextoImoveis';
import { Financeiro } from './services/financeiro';
import { Notificacoes } from './services/notificacoes';
import { Destaques } from './services/destaques';
import { Renegociacao } from './services/renegociacao';
import { PagamentoCartao } from './services/pagamentoCartao';
import { Sindico } from './services/sindico';
import { Riva, Direcional } from './temas';
import initHotjarWithConfigs from './Hotjar/configs';
import { initDatadogRum } from './DataDog/configs';

const App = () => {
  initHotjarWithConfigs();
  initDatadogRum();

  return (
    <ThemeProvider theme={{ Riva, Direcional }}>
      <FlagsProvider value={flags}>
        <Destaques>
          <Notificacoes>
            <AuthProvider>
              <GetData>
                <ListaImoveis>
                  <GetMeuPerfil>
                    <Solicitacoes>
                      <PagamentoCartao>
                        <Financeiro>
                          <Renegociacao>
                            <Sindico>
                              <GlobalStyle />
                              <Routes />
                            </Sindico>
                          </Renegociacao>
                        </Financeiro>
                      </PagamentoCartao>
                    </Solicitacoes>
                  </GetMeuPerfil>
                </ListaImoveis>
              </GetData>
            </AuthProvider>
          </Notificacoes>
        </Destaques>
      </FlagsProvider>
    </ThemeProvider>
  );
};

export default App;
